/* eslint-disable */
// @ts-nocheck

import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import useServer from '../../api/useServerMain'
import { useAppSelector } from '../../store/hooks'
import { validateEmail } from '../../utils/helpers'
import FileInput from '../forms/FileInput'
import Input from '../forms/Input'
import Button from '../misc/Button'

interface UserModal {
  closeModal: Function
}

const UserModal = ({ closeModal }: UserModal) => {
  const { editUser, isFetching } = useServer()
  const { user } = useAppSelector((state) => state.init)
  const { control, handleSubmit } = useForm<Record<string, string | number>>()
  const onSubmit: SubmitHandler<Record<string, string | number>> = (data) => {
    editUser(data, closeModal)
  }

  return (
    <div>
      <h2 className="text-center text-xl font-semibold text-slate-600 underline">
        Configurar mi usuario
      </h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-3 flex-col">
          <Input
            control={control}
            defaultValue={user?.username}
            label="Usuario en el sistema"
            name="username"
            rules={{ required: 'Campo requerido' }}
          />
          <Input
            control={control}
            defaultValue={user?.displayName}
            label="Nombre público"
            name="displayName"
            rules={{ required: 'Campo requerido' }}
          />
          <Input
            control={control}
            defaultValue={user?.email}
            label="Correo electrónico"
            name="email"
            rules={{
              validate: {
                match: (value) =>
                  validateEmail(value) ||
                  'Inserte una dirección de correo válida',
              },
            }}
          />
        </div>
        <FileInput
          control={control}
          defaultImg={
            user?.avatarId
              ? { id: user?.avatarId, src: user?.avatar?.src }
              : undefined
          }
          label="Foto de perfil"
          name="avatarId"
        />

        <div className="mt-3">
          <Button
            color="slate-600"
            disabled={isFetching}
            full
            loading={isFetching}
            name="Actualizar"
            type="submit"
          />
        </div>
      </form>
    </div>
  )
}

export default UserModal
